module.exports = __webpack_public_path__ + "static/media/EDP_Loop_Graphic.e7bb4965.jpg";